import {
  RequestBasketballPostTeamGameHelpouts,
  RequestBasketballUpdateTeamGameMeetAt,
  RequestBasketballUpdateTeamGameNominees,
} from '@hefe/models';
import { createAsyncThunk } from '@reduxjs/toolkit';
import API from '../../../../api/api';

const setBasketballTeamGameMeetingAt = createAsyncThunk(
  'basketballGames/setTeamMeetingAt',
  async (
    data: { gameId: number; data: RequestBasketballUpdateTeamGameMeetAt },
    thunkAPI
  ) => {
    const response = await API.basketballGames().updateMeetAt(
      data.gameId,
      data.data
    );
    return response?.data;
  }
);

const setBasketballTeamGameNominees = createAsyncThunk(
  'basketballGames/setTeamNominees',
  async (
    data: { gameId: number; data: RequestBasketballUpdateTeamGameNominees },
    thunkAPI
  ) => {
    const response = await API.basketballGames().updateNominees(
      data.gameId,
      data.data
    );
    return response?.data;
  }
);

const setBasketballTeamGameHelpouts = createAsyncThunk(
  'basketballGames/setTeamHelpouts',
  async (data: RequestBasketballPostTeamGameHelpouts, thunkAPI) => {
    const response = await API.basketballGames().updateHelpouts(data);
    return response?.data;
  }
);

export {
  setBasketballTeamGameMeetingAt,
  setBasketballTeamGameNominees,
  setBasketballTeamGameHelpouts,
};
